<template>
  <div class="cal-box" ref="calendarBoxEl" :class="{
    'expanded': isExpanded == id,
    'has-expand-link': boxHasScroll
    }">
    <div class="day-label-wrapper">
      <h4 class="week-day" v-if="previewMode === calendarViewModes.WEEK">{{getDayName(item.date)}}</h4>
      <h2
        class="day-label"
        :class="{'week-day-label': previewMode === calendarViewModes.WEEK}">
        {{formatHeaderLabel(item.date)}}
        <span class="close-expanded fa-pull-right" @click="collapse(id)"><img src="@/assets/images/icons/close-icon.png" alt="close" /></span>
      </h2>
    </div>
    <div class="events">

      <vue-scroll 
        :ops="scrollConfig" 
        @handle-resize="displayExpandBarBtn">
        <div class="event-rows-block">
          <div class="event-row" v-for="(event, i) in item.events" :key="i">
            <div
              :class="{'invalid-activity-label': event.invalidTooltipMessage}"
              class="event-label-wrapper">

              <button
                v-b-tooltip="{
                  title: event.invalidTooltipMessage,
                  container: 'body',
                  boundary: 'viewport',
                  trigger: 'focus',
                  template: tooltipInvalidTemplate,
                  html: true,
                  placement: 'topright'
                }"
                v-if="event.invalidTooltipMessage && event.invalidTooltipIcon && event.status === activityStatuses.INVALID"
                :class="event.invalidTooltipIcon"
                class="error-icon cursor-pointer tooltip-btn"></button>

              <i
              v-b-tooltip="{
                title: event.invalidTooltipMessage,
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }"
              v-if="event.invalidTooltipMessage && event.invalidTooltipIcon && event.status !== activityStatuses.INVALID"
              :class="event.invalidTooltipIcon"
              class="error-icon cursor-pointer"></i>

              <span class="event-label"
                :class="{
                  'event-label-green': event.labelColor === 'green',
                  'event-label-red': event.labelColor === 'red',
                  'event-label-purple': event.labelColor === 'purple',
                  'event-label-orange': event.labelColor === 'neutral',
                }"></span>
            </div>

            <span class="event-link" v-if="!event.routerLink">
              {{event.title}}
            </span>
            <router-link v-if="event.routerLink" class="event-link" :to="event.routerLink" @click.native="logClick(event)">
              {{event.title}}
            </router-link>
          </div>
        </div>
      </vue-scroll>
    </div>
    <div class="expand-bar" @click="expand(id)">
      <img src="@/assets/images/icons/more-icon.png" class="extand-icon" alt="more">
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'
import { ACTIVITY_STATUS } from '@/constants/SessionConsts'

export default {
  name: 'CalendarBox',
  props: [
    'item',
    'id',
    'isExpanded',
    'previewMode'
  ],
  data () {
    return {
      calendarViewModes: CALENDAR_VIEW_MODES,
      activityStatuses: ACTIVITY_STATUS,
      boxHasScroll: false,
      scrollConfig: {
        bar: {
          keepShow: true,
          onlyShowBarOnScroll: false,
          background: '#5E5E62',
          hoverStyle: true
        }
      },
      tooltipTemplate: '<div class="tooltip event-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      tooltipInvalidTemplate: '<div class="tooltip event-tooltip tooltip-invalid" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.displayExpandBarBtn()
    })
  },
  methods: {
    displayExpandBarBtn () {
      if (this.previewMode === CALENDAR_VIEW_MODES.MONTH) {
        const calendarBox = this.$refs.calendarBoxEl
        const calendarBoxInnerHeight = calendarBox.querySelector('.__view').clientHeight
        const calendarBoxMaxHeight = calendarBox.querySelector('.events').clientHeight

        if (calendarBoxInnerHeight > calendarBoxMaxHeight) {
          this.boxHasScroll = true
        } else {
          this.boxHasScroll = false
        }
      } else {
        this.boxHasScroll = false
      }
    },
    formatHeaderLabel (date) {
      if (this.previewMode === CALENDAR_VIEW_MODES.MONTH) {
        return date.getDate()
      } else {
        return moment(date).locale(this.$i18n.locale).format('D MMM')
      }
    },
    getDayName (date) {
      return moment(date).locale(this.$i18n.locale).format('dddd')
    },
    expand (id) {
      this.$emit('expand', id)
    },
    collapse (id) {
      this.$emit('collapse', id)
    },
    logClick(event) {
      var activityType
      switch (event.labelColor) {
        case "red":
            activityType = "GAME"
          break;
        case "green":
            activityType = "TRAINING"
          break;
        case "purple":
            activityType = "OTHER"
          break;
        case "neutral":
            activityType = "INDIVIDUAL"
          break;
      
        default:
          activityType = null
          break;
      }
      this.$amplitude.logEvent('pwa: click on calendar activity', {activityType: activityType})
    }
  },
  watch: {
    item () {
      this.boxHasScroll = false
      this.displayExpandBarBtn()
    }
  }
}
</script>

<style lang="scss" scoped>
  .invalid-activity-label {
    width: 45px;
  }

  .error-icon {
    color: $coffee;
  }
</style>
